package com.varabyte.kobweb.showcase.site.ui.theme

import com.varabyte.kobweb.compose.ui.graphics.Color

object SiteColors {
    val KobwebBlue = Color.rgb(0x3C83EF)
    val KobwebGold = Color.rgb(0xF3DB5B)
    val KobwebGoldDark = Color.rgb(0xC89600)

    val MakoGreen       = Color.rgb(0x00FF87)
    val MakoDeep        = Color.rgb(0x00CC6A)
    val MakoSubtle      = Color.rgb(0x003D28)

    val NightBlue       = Color.rgb(0x06080B)
    val SlateBlue       = Color.rgb(0x0D1117)
    val SlateBlueLight  = Color.rgb(0x13171F)
    val SlateBlueHover  = Color.rgb(0x1C2230)
    val BorderDark      = Color.rgb(0x21262D)

    val CloudWhite      = Color.rgb(0xE8ECEF)
    val NeutralLight    = Color.rgb(0xF4F6F8)
    val SurfaceLight    = Color.rgb(0xFFFFFF)
    val BorderLight     = Color.rgb(0xC0C8D0)
    val CobwebLight     = Color.rgb(0x90A0B0)

    val MakoGreenDark   = Color.rgb(0x00C878)
    val MakoDeepDark    = Color.rgb(0x00AE69)

    val TagBgDark       = Color.rgb(0x1A3A2A)
    val TagTextDark     = Color.rgb(0x00FF87)
    val TagBgLight      = Color.rgb(0xEAF6F0)
    val TagTextLight    = Color.rgb(0x00663F)

    val SkeletonBase    = Color.rgb(0x161B22)
    val SkeletonShimmer = Color.rgb(0x21262D)
}
